<template>
    <div id="vacation-schedule">
        <vs-row>
            <vs-col w="12"><br /><br /></vs-col>
        </vs-row>
        <vx-card :title="cardTitle">
            <div class="vx-row mb-4">
                <!-- 월 네비게이션 -->
                <div class="vx-col w-full lg:w-1/2 month-nav">
                    <vs-button color="dark" type="line" icon-pack="feather" icon="icon-arrow-left" @click="prevMonth"></vs-button>
                    <span class="mx-4 text-lg font-bold">{{ displayMonth }}</span>
                    <vs-button color="dark" type="line" icon-pack="feather" icon="icon-arrow-right" @click="nextMonth"></vs-button>
                </div>
                <!-- 직원 필터 + 등록 버튼 -->
                <div class="vx-col w-full lg:w-1/2 text-right">
                    <v-select
                        v-model="filterStaff"
                        :options="staffOptions"
                        placeholder="전체 직원"
                        class="staff-filter-select mr-4"
                    ></v-select>
                    <vs-button color="primary" @click="openModal()">+ 연차 등록</vs-button>
                </div>
            </div>

            <!-- 달력 그리드 -->
            <div class="calendar-container">
                <table class="calendar-table">
                    <thead>
                        <tr>
                            <th class="day-header sunday">일</th>
                            <th class="day-header">월</th>
                            <th class="day-header">화</th>
                            <th class="day-header">수</th>
                            <th class="day-header">목</th>
                            <th class="day-header">금</th>
                            <th class="day-header saturday">토</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(week, weekIndex) in calendarWeeks" :key="weekIndex">
                            <td
                                v-for="(day, dayIndex) in week"
                                :key="dayIndex"
                                :class="getCellClass(day, dayIndex)"
                                @click="onDayClick(day)"
                            >
                                <div class="day-number" v-if="day.date">{{ day.day }}</div>
                                <div class="vacation-list" v-if="day.vacations && day.vacations.length > 0">
                                    <div
                                        v-for="(vacation, vIndex) in day.vacations"
                                        :key="vIndex"
                                        :class="['vacation-item', getVacationClass(vacation.VACATION_TYPE)]"
                                        @click.stop="onVacationClick(vacation)"
                                    >
                                        <span class="staff-name">{{ vacation.STAFF_NAME }}</span>
                                        <span class="vacation-type">{{ getTypeLabel(vacation.VACATION_TYPE) }}</span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- 범례 -->
            <div class="legend mt-4">
                <span class="legend-item"><span class="legend-color full"></span> 전일</span>
                <span class="legend-item"><span class="legend-color am"></span> 오전반차</span>
                <span class="legend-item"><span class="legend-color pm"></span> 오후반차</span>
            </div>
        </vx-card>

        <!-- 연차 등록 모달 -->
        <vs-popup title="연차 등록" :active.sync="showModal">
            <div class="vx-row mb-4">
                <div class="vx-col w-full">
                    <label class="vs-select--label">직원</label>
                    <v-select
                        v-model="form.staff"
                        :options="staffSelectOptions"
                        :disabled="true"
                        placeholder="직원 선택"
                    ></v-select>
                    <span class="text-sm text-gray-500">
                        * 본인의 연차만 등록할 수 있습니다.
                    </span>
                </div>
            </div>
            <div class="vx-row mb-4">
                <div class="vx-col w-full">
                    <label class="vs-select--label">날짜</label>
                    <datepicker
                        v-model="form.date"
                        :format="customFormatter"
                        placeholder="날짜 선택"
                        :language="ko"
                    ></datepicker>
                </div>
            </div>
            <div class="vx-row mb-4">
                <div class="vx-col w-full">
                    <label class="vs-select--label">유형</label>
                    <div class="mt-2">
                        <vs-radio v-model="form.type" vs-value="FULL" class="mr-4">전일</vs-radio>
                        <vs-radio v-model="form.type" vs-value="AM" class="mr-4">오전반차</vs-radio>
                        <vs-radio v-model="form.type" vs-value="PM">오후반차</vs-radio>
                    </div>
                </div>
            </div>
            <div class="vx-row mb-4">
                <div class="vx-col w-full">
                    <label class="vs-select--label">사유 (선택)</label>
                    <vs-input v-model="form.memo" placeholder="사유 입력" class="w-full"></vs-input>
                </div>
            </div>
            <div class="text-right">
                <vs-button color="dark" type="line" @click="showModal = false" class="mr-2">취소</vs-button>
                <vs-button color="primary" @click="saveVacation">등록</vs-button>
            </div>
        </vs-popup>
    </div>
</template>

<script>
import axiosClass from '@/../util/axiosClass';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import { ko } from 'vuejs-datepicker/dist/locale';
import vSelect from 'vue-select';
import store from '@/store/store';

export default {
    components: {
        Datepicker,
        'v-select': vSelect
    },
    data() {
        return {
            cardTitle: '연차 관리',
            currentMonth: moment().format('YYYYMM'),
            vacationList: [],
            staffList: [],
            filterStaff: null,
            showModal: false,
            form: {
                staff: null,
                date: null,
                type: 'FULL',
                memo: ''
            },
            ko: ko,
            userUid: null,
            userLevel: 99
        };
    },
    computed: {
        displayMonth() {
            return moment(this.currentMonth, 'YYYYMM').format('YYYY년 MM월');
        },
        isAdmin() {
            return this.userLevel <= 2;
        },
        staffOptions() {
            return [
                { id: 0, label: '전체 직원' },
                ...this.staffList.map(s => ({ id: s.UID, label: s.USERNAME }))
            ];
        },
        staffSelectOptions() {
            // 본인만 선택 가능
            const me = this.staffList.find(s => s.UID === this.userUid);
            return me ? [{ id: me.UID, label: me.USERNAME }] : [];
        },
        calendarWeeks() {
            const weeks = [];
            const firstDay = moment(this.currentMonth, 'YYYYMM').startOf('month');
            const lastDay = moment(this.currentMonth, 'YYYYMM').endOf('month');
            const startDayOfWeek = firstDay.day();
            const daysInMonth = lastDay.date();

            // 연차 데이터를 날짜별로 그룹화
            const vacationByDate = {};
            this.vacationList.forEach(v => {
                const dateKey = moment(v.VACATION_DATE).format('YYYY-MM-DD');
                if (!vacationByDate[dateKey]) {
                    vacationByDate[dateKey] = [];
                }
                vacationByDate[dateKey].push(v);
            });

            let currentDay = 1;
            let week = [];

            // 첫 주 시작 전 빈 셀
            for (let i = 0; i < startDayOfWeek; i++) {
                week.push({ date: null, day: null, vacations: [] });
            }

            // 날짜 채우기
            while (currentDay <= daysInMonth) {
                const dateStr = moment(this.currentMonth, 'YYYYMM').date(currentDay).format('YYYY-MM-DD');
                week.push({
                    date: dateStr,
                    day: currentDay,
                    vacations: vacationByDate[dateStr] || [],
                    isToday: dateStr === moment().format('YYYY-MM-DD')
                });

                if (week.length === 7) {
                    weeks.push(week);
                    week = [];
                }
                currentDay++;
            }

            // 마지막 주 빈 셀 채우기
            while (week.length > 0 && week.length < 7) {
                week.push({ date: null, day: null, vacations: [] });
            }
            if (week.length > 0) {
                weeks.push(week);
            }

            return weeks;
        }
    },
    async mounted() {
        this.userUid = store.getters.getUID;
        this.userLevel = store.getters.getUserLevel || 99;
        await this.loadStaffList();
        await this.loadVacationList();

        if (!this.isAdmin) {
            const me = this.staffList.find(s => s.UID === this.userUid);
            if (me) {
                this.form.staff = { id: me.UID, label: me.USERNAME };
            }
        }
    },
    methods: {
        async loadStaffList() {
            try {
                const { data } = await axiosClass.get('/api/vacation/staff', {}, true);
                this.staffList = data.list || [];
            } catch (error) {
                console.error('직원 목록 로드 실패:', error);
            }
        },
        async loadVacationList() {
            try {
                const staffUid = (this.filterStaff && this.filterStaff.id) || 0;
                const { data } = await axiosClass.get('/api/vacation/list', {
                    yearMonth: this.currentMonth,
                    staffUid: staffUid
                }, true);
                this.vacationList = data.list || [];
            } catch (error) {
                console.error('연차 목록 로드 실패:', error);
                this.vacationList = [];
            }
        },
        prevMonth() {
            this.currentMonth = moment(this.currentMonth, 'YYYYMM').subtract(1, 'month').format('YYYYMM');
            this.loadVacationList();
        },
        nextMonth() {
            this.currentMonth = moment(this.currentMonth, 'YYYYMM').add(1, 'month').format('YYYYMM');
            this.loadVacationList();
        },
        openModal(selectedDate = null) {
            this.form.date = selectedDate ? new Date(selectedDate) : null;
            this.form.type = 'FULL';
            this.form.memo = '';
            // 항상 본인만 선택
            const me = this.staffList.find(s => s.UID === this.userUid);
            if (me) {
                this.form.staff = { id: me.UID, label: me.USERNAME };
            }
            this.showModal = true;
        },
        onDayClick(day) {
            if (day.date) {
                this.openModal(day.date);
            }
        },
        onVacationClick(vacation) {
            if (!this.canDelete(vacation)) {
                this.$vs.notify({ title: '알림', text: '삭제 권한이 없습니다.', color: 'warning' });
                return;
            }

            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: '연차 삭제',
                text: `${vacation.STAFF_NAME}님의 ${this.getTypeLabel(vacation.VACATION_TYPE)} 연차를 삭제하시겠습니까?`,
                acceptText: '삭제',
                cancelText: '취소',
                accept: () => {
                    this.deleteVacation(vacation.VACATION_SEQ);
                }
            });
        },
        async saveVacation() {
            if (!this.form.staff) {
                this.$vs.notify({ title: '오류', text: '직원을 선택해주세요.', color: 'danger' });
                return;
            }
            if (!this.form.date) {
                this.$vs.notify({ title: '오류', text: '날짜를 선택해주세요.', color: 'danger' });
                return;
            }

            try {
                const vacationDate = moment(this.form.date).format('YYYY-MM-DD');
                await axiosClass.post('/api/vacation/save', {
                    staffUid: this.form.staff.id,
                    vacationDate: vacationDate,
                    vacationType: this.form.type,
                    memo: this.form.memo
                }, true);

                this.$vs.notify({ title: '성공', text: '연차가 등록되었습니다.', color: 'success' });
                this.showModal = false;
                await this.loadVacationList();
            } catch (error) {
                console.error('연차 등록 실패:', error);
                this.$vs.notify({ title: '오류', text: (error.response && error.response.data && error.response.data.err_msg) || '연차 등록에 실패했습니다.', color: 'danger' });
            }
        },
        async deleteVacation(seq) {
            try {
                await axiosClass.delete('/api/vacation/' + seq, {}, true);
                this.$vs.notify({ title: '성공', text: '연차가 삭제되었습니다.', color: 'success' });
                await this.loadVacationList();
            } catch (error) {
                console.error('연차 삭제 실패:', error);
                this.$vs.notify({ title: '오류', text: (error.response && error.response.data && error.response.data.err_msg) || '연차 삭제에 실패했습니다.', color: 'danger' });
            }
        },
        canDelete(item) {
            // 본인의 연차만 삭제 가능
            return item.STAFF_UID === this.userUid;
        },
        customFormatter(date) {
            return moment(date).format('YYYY-MM-DD');
        },
        getTypeLabel(type) {
            switch (type) {
                case 'FULL': return '전일';
                case 'AM': return '오전';
                case 'PM': return '오후';
                default: return type;
            }
        },
        getVacationClass(type) {
            switch (type) {
                case 'FULL': return 'vacation-full';
                case 'AM': return 'vacation-am';
                case 'PM': return 'vacation-pm';
                default: return '';
            }
        },
        getCellClass(day, dayIndex) {
            const classes = ['calendar-cell'];
            if (!day.date) {
                classes.push('empty-cell');
            } else {
                if (day.isToday) {
                    classes.push('today');
                }
                if (dayIndex === 0) {
                    classes.push('sunday');
                }
                if (dayIndex === 6) {
                    classes.push('saturday');
                }
            }
            return classes;
        }
    },
    watch: {
        filterStaff() {
            this.loadVacationList();
        }
    }
};
</script>

<style scoped>
#vacation-schedule {
    padding: 10px;
    margin-top: 20px;
}

.month-nav {
    display: flex;
    align-items: center;
}

/* 직원 필터 v-select 스타일 수정 */
.staff-filter-select {
    width: 200px;
    display: inline-block;
    vertical-align: middle;
}

.staff-filter-select::v-deep .vs__selected {
    width: auto !important;
    max-width: 150px;
}

.staff-filter-select::v-deep .vs__selected-options {
    flex-wrap: nowrap;
}

.calendar-container {
    overflow-x: auto;
}

.calendar-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
}

.calendar-table th,
.calendar-table td {
    border: 1px solid #e0e0e0;
    text-align: left;
    vertical-align: top;
}

.day-header {
    background-color: #f5f5f5;
    padding: 10px;
    text-align: center;
    font-weight: bold;
}

.day-header.sunday {
    color: #e74c3c;
}

.day-header.saturday {
    color: #3498db;
}

.calendar-cell {
    min-height: 100px;
    padding: 5px;
    cursor: pointer;
    transition: background-color 0.2s;
}

.calendar-cell:hover {
    background-color: #f8f9fa;
}

.calendar-cell.empty-cell {
    background-color: #fafafa;
    cursor: default;
}

.calendar-cell.today {
    background-color: #fff8e1;
}

.calendar-cell.sunday .day-number {
    color: #e74c3c;
}

.calendar-cell.saturday .day-number {
    color: #3498db;
}

.day-number {
    font-weight: bold;
    font-size: 14px;
    margin-bottom: 5px;
}

.vacation-list {
    display: flex;
    flex-direction: column;
    gap: 3px;
}

.vacation-item {
    padding: 3px 6px;
    border-radius: 4px;
    font-size: 11px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.vacation-item:hover {
    opacity: 0.8;
}

.vacation-full {
    background-color: #fee2e2;
    color: #dc2626;
    border-left: 3px solid #dc2626;
}

.vacation-am {
    background-color: #fef3c7;
    color: #d97706;
    border-left: 3px solid #d97706;
}

.vacation-pm {
    background-color: #dbeafe;
    color: #2563eb;
    border-left: 3px solid #2563eb;
}

.staff-name {
    font-weight: 500;
}

.vacation-type {
    font-size: 10px;
    opacity: 0.8;
}

.legend {
    display: flex;
    gap: 20px;
    justify-content: center;
    padding: 10px;
    background-color: #f9f9f9;
    border-radius: 4px;
}

.legend-item {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 12px;
}

.legend-color {
    width: 16px;
    height: 16px;
    border-radius: 3px;
}

.legend-color.full {
    background-color: #fee2e2;
    border-left: 3px solid #dc2626;
}

.legend-color.am {
    background-color: #fef3c7;
    border-left: 3px solid #d97706;
}

.legend-color.pm {
    background-color: #dbeafe;
    border-left: 3px solid #2563eb;
}

.vs-popup--content {
    min-width: 400px;
}
</style>
